import { render, staticRenderFns } from "./SMSBulkTaskDetail.vue?vue&type=template&id=5f854daf&scoped=true"
import script from "./SMSBulkTaskDetail.vue?vue&type=script&lang=js"
export * from "./SMSBulkTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./SMSBulkTaskDetail.vue?vue&type=style&index=0&id=5f854daf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f854daf",
  null
  
)

export default component.exports